import React from "react";
import rehypeReact from "rehype-react"
import { Box, Flex, Text } from 'rebass'
import Img from 'gatsby-image';
import styled from 'styled-components'
import ImageParser from '../components/markdown/ImageParser'
import { fonts, colors, fontSizes } from '../theme'
import {AccountIcon, TagMultipleIcon,CalendarIcon} from 'mdi-react'
import Link from 'gatsby-link'

const DetailsContainer = styled(Box)`
  font-family: ${fonts.article};
  max-width: 100%;
  font-size: ${fontSizes[3]+'px'};
  word-break: break-word;
  &.article-container:first-letter {
    font-weight: bold;
    font-size: ${fontSizes[6]+'px'};
  };
  color: ${colors.greyDark}
`
const TextDetails = styled(Text)`
  list-style: none;
  text-align: left;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  word-break: break-word;
  color: ${colors.greyDark};
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[2] + 'px'};
`

const Article = ({ data }) => {
  const post = data.markdownRemark;

  const renderAst = new rehypeReact({
    createElement: React.createElement,
    components: {
      "img": ImageParser,
      "pre": DetailsContainer
    },
  }).Compiler

  return (
    <div>
    <Flex style={{fontFamily: fonts.secondary}} flexDirection={['column','column','row']} px={[2,2,5]} pt={[4,4,6]}>
      <Box width={[1,1,1/2]} pt={4}>
      <Box p={[1,1,2,2]} style={{fontSize:fontSizes[6]+'px', wordBreak:'break-word',color: "#000000d9"}}> {post.frontmatter.title}</Box>
      <Box p={[1,1,2,2]} color={colors.greyDark} style={{fontSize:fontSizes[4]+'px', wordBreak:'break-word'}}>{post.frontmatter.tagline}</Box>
      <Flex flexDirection={['column','row', 'column', 'row']} justifyContent='flex-start' p={[1,1,2]}color={colors.greyDark} style={{fontSize:fontSizes[1]+'px',}}>
      <Flex display="inline" pr={[1,2,4]}>
          <AccountIcon className='IconBox4' />
          <TextDetails>{`${post.frontmatter.author}`}</TextDetails>
        </Flex>
        <Flex display="inline" pr={[1,2,4]}>
          <TagMultipleIcon className='IconBox4'/>
          <TextDetails>{`${post.frontmatter.category}`}</TextDetails>
        </Flex>
        <Flex display="inline" >
          <CalendarIcon className='IconBox4' />
          <TextDetails>{`${post.frontmatter.dateTime}`}</TextDetails>
        </Flex>
      </Flex>
      </Box>
      <Box width={[1,1,1/2]}>
      <Img style={{maxHeight: '350px'}} sizes={post.frontmatter.cover.childImageSharp.sizes} imgStyle={{objectPosition: 'center center'}} />
      </Box>
    </Flex>
      <DetailsContainer className="article-container" px={[2,4,5,7]} py={[1,1,1,3]}>
        {
          renderAst(post.htmlAst)
        }
      </DetailsContainer>
      </div>
  );
};

export default Article;

export const query = graphql`
  query articlePostQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      htmlAst
      frontmatter {
        title
        tagline
        author
        category
        dateTime(formatString: "DD MMMM, YYYY")
        cover {
          childImageSharp {
            sizes(maxWidth: 1600, quality: 100, traceSVG: { color: "#f3f3f3" }) {
              ...GatsbyImageSharpSizes_tracedSVG
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/article.js